<div class="callback-wrapper">
  <p-progressSpinner strokeWidth="4"></p-progressSpinner>
  <p>Autenticando...</p>
</div>
